import { jsx as _jsx } from "react/jsx-runtime";
import { FormattedMessage } from "react-intl";
import { EduIDButton } from "./EduIDButton";
export const ShowAndHideButton = ({ isShown, onClick }) => {
    return (_jsx(EduIDButton, { id: "show-hide-button", buttonstyle: "txt-toggle-btn link sm", onClick: onClick, children: isShown ? (_jsx(FormattedMessage, { id: "showAndHideButton.hide", defaultMessage: "HIDE", description: "hide button" })) : (_jsx(FormattedMessage, { id: "showAndHideButton.show", defaultMessage: "SHOW", description: "show button" })) }));
};
